const WhitePaper = {
  english: 'https://qlear-asserts.pek3a.qingstor.com/covidindexwhitepaper/QLEAR.Index.Whitepaper.EN.pdf',
  chinese: 'https://qlear-asserts.pek3a.qingstor.com/covidindexwhitepaper/QLEAR.Index.Whitepaper.CN.pdf'
}

export default WhitePaper
